import { render, staticRenderFns } from "./receviceAddress.vue?vue&type=template&id=27488985&scoped=true"
import script from "./receviceAddress.vue?vue&type=script&lang=js"
export * from "./receviceAddress.vue?vue&type=script&lang=js"
import style0 from "./receviceAddress.vue?vue&type=style&index=0&id=27488985&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27488985",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27488985')) {
      api.createRecord('27488985', component.options)
    } else {
      api.reload('27488985', component.options)
    }
    module.hot.accept("./receviceAddress.vue?vue&type=template&id=27488985&scoped=true", function () {
      api.rerender('27488985', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/receviceAddress.vue"
export default component.exports